import React from 'react';
import { Box } from '@mui/material';
import * as S from './SectionItem.styles';
const SectionItem = ({
  orientation = 'horizontal',
  icon,
  value,
  label,
  className
}) => {
  const Wrapper = orientation === 'horizontal' ? React.Fragment : Box;
  return /*#__PURE__*/React.createElement(S.Root, {
    className: className
  }, icon && /*#__PURE__*/React.createElement(S.Icon, null, icon), /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(S.Label, {
    orientation: orientation
  }, label), /*#__PURE__*/React.createElement(S.Value, null, value)));
};
export default SectionItem;